import React from "react"
import { useSnackbar } from "notistack"
import { RoboComercial } from "../../../services/apiRobo"
import { erroMsg } from "../components/comum"

/** Agenda de apresentações (porte da rail 📅). Lembrete automático ao lead 30 min antes. */
export function Agenda() {
    const { enqueueSnackbar } = useSnackbar()
    const [itens, setItens] = React.useState<any[]>([])
    const [carregando, setCarregando] = React.useState(false)

    const carregar = React.useCallback(async () => {
        setCarregando(true)
        try {
            const r = await RoboComercial.listarAgenda()
            setItens(Array.isArray(r) ? r : r?.items || [])
        } catch (e) {
            enqueueSnackbar(erroMsg(e), { variant: "error" })
        } finally {
            setCarregando(false)
        }
    }, [enqueueSnackbar])

    React.useEffect(() => {
        carregar()
    }, [carregar])

    async function remover(id: number) {
        try {
            await RoboComercial.removerAgenda(id)
            enqueueSnackbar("Compromisso removido.", { variant: "success" })
            carregar()
        } catch (e) {
            enqueueSnackbar(erroMsg(e), { variant: "error" })
        }
    }

    return (
        <section className="panel active" style={{ display: "block" }}>
            <div className="panel-actions">
                <h3 style={{ margin: 0 }}>📅 Agenda de apresentações</h3>
                <button className="ghost" onClick={carregar}>
                    ↻ Atualizar
                </button>
            </div>
            <div className="muted small" style={{ padding: "0 12px 8px" }}>
                Compromissos criados pela IA quando o lead confirma horário. Conflitos são permitidos — o time se organiza.
            </div>
            {carregando && <div className="muted small" style={{ padding: 12 }}>Carregando…</div>}
            {!carregando && itens.length === 0 && <div className="empty">Nenhum compromisso agendado.</div>}
            <ul className="list" style={{ listStyle: "none", margin: 0, padding: "0 12px 12px" }}>
                {itens.map(a => (
                    <li
                        key={a.id}
                        style={{
                            background: "var(--panel)",
                            border: "1px solid var(--border)",
                            borderRadius: "var(--radius)",
                            padding: 12,
                            marginBottom: 8,
                        }}
                    >
                        <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                            <strong>{a.titulo || a.nomeContato || "Apresentação"}</strong>
                            <span className="muted small">{fmt(a.inicio)}</span>
                        </div>
                        <div className="muted small">
                            {a.nomeContato ? a.nomeContato + " · " : ""}
                            {a.duracaoMin ? a.duracaoMin + " min" : ""}
                            {a.status ? " · " + a.status : ""}
                        </div>
                        {a.notas ? <div className="small">{a.notas}</div> : null}
                        {a.linkSala ? (
                            <div className="small">
                                <a href={a.linkSala} target="_blank" rel="noreferrer">
                                    Sala da reunião
                                </a>
                            </div>
                        ) : null}
                        <div style={{ marginTop: 6 }}>
                            <button className="ghost warning" onClick={() => remover(a.id)}>
                                🗑 Remover
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    )
}

function fmt(v: any): string {
    if (!v) return ""
    try {
        return new Date(v).toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        })
    } catch {
        return ""
    }
}

export default Agenda
